import { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from "yup";
import { TitleParamContext } from '../../context/TitleContext';
import { HttpPostData, JumpPage } from '../../common/Util';
import { ResponseParamBase } from '../../common/Types';
import { emailValidateion } from "../../common/Valitation";
import market from "../../css/market.module.scss";
import base from "../../css/base.module.css";
import { OnsiteTextField } from "../../customelements/CustomInput";
import { PageTypeParamConverter, RegisterPageType, RegisterPageInfo, RegisterPageTypeEnum } from "../../context/RegisterPageTypeContext";
import { MessageParam } from '../Message';


interface IFormInputs {
    eMail: string
}

export type ResponseParam = ResponseParamBase & {
    messageList: string[],
}

const schema = Yup.object({
    eMail: emailValidateion,
}).required();


export const RegisterTrialLicense = () => {
    const titleConext = useContext(TitleParamContext);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [errorMessageList, setErrorMessageList] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const { handleSubmit, control, formState: { errors, isValid } } = useForm<IFormInputs>({
        defaultValues: {
            eMail: ""
        },
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
    });

    useEffect(() => {
        titleConext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "お試しライセンス発行", secondSubTitle: "" });
    });

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs) => {
        setErrorMessage((value) => { return "" });
        await HttpPostData<ResponseParam>("/userregister/existtrialuser", { eMail: data.eMail }, setIsLoading)
            .then((response) => {
                if (response.data.resultFlg) {
                    JumpPage<MessageParam>("complete", { message: response.data.message, displayButton: false }, "", navigate);
                } else {
                    setErrorMessage(response.data.message);
                    setErrorMessageList(response.data.messageList);
                }
            })
            .catch(() => {
                setErrorMessage((value) => { return "登録に失敗しました。" });
            });
    }

    return (
        <>
            <section className={market.marketArea}>
                <div className={market.marketAreaInner}>
                    <p className={base.messageFont}>指定されたメールアドレスに対して、お試しライセンスコードをお送りします。</p>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={market["layoutBox-l"]} >
                            <div className={market.marketInputLongTitle}>
                                <h3>メールアドレス</h3>
                            </div>                        
                            <div className={market.marketInputTitleContents}>
                                <Controller
                                    name="eMail"                                
                                    control={control}
                                    render={({ field }) => (
                                        <OnsiteTextField
                                            {...field}
                                            error={errors.eMail ? true : false}
                                            helperText={errors.eMail?.message}
                                            margin="normal"
                                            type="email"
                                        ></OnsiteTextField>
                                    )}
                                ></Controller>
                            </div>
                        </div>
                        <div className={base.errorMessage}>{errorMessage}</div>
                        {
                            errorMessageList.map((field, index) => {
                                return (
                                    <div className={base.errorMessage}>{field}</div>
                                )
                            })
                        }
                        <div className={market.marketFooterArea}>
                            <button style={{ visibility: "hidden" }} className={market.marketBackButton} type="button">戻る</button>
                            <button className={market.marketButton} type="submit" disabled={!isValid || isLoading}>送信</button>
                            <button style={{ visibility: "hidden" }} className={market.marketBackButton} type="button">次へ</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    )
}

export const TrialRedirect = () => {

    const titleConext = useContext(TitleParamContext);
    const navigate = useNavigate();

    useEffect(() => {
        titleConext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "お試しライセンス発行", secondSubTitle: "" });
        JumpPage<RegisterPageInfo>("/ConsentForm", { registerPageType: RegisterPageTypeEnum.TrialLicense }, "新規登録", navigate);
    });

    return (
        <>
        テスト
        </>
    );
}